var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "toolbar",
        {
          attrs: { title: "My Assigned Loads (" + _vm.bookedLoads.length + ")" }
        },
        [
          _c(
            "v-icon",
            {
              on: {
                click: function($event) {
                  return _vm.getBookedLoads()
                }
              }
            },
            [_vm._v("refresh")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.$vuetify.breakpoint.mdAndUp
        ? _c(
            "div",
            { staticClass: "pt-3" },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-tabs",
                    {
                      attrs: { color: "white", grow: "" },
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c("v-tabs-slider", { attrs: { color: "primary" } }),
                      _vm._v(" "),
                      _c("v-tab", { key: "Scheduled" }, [
                        _vm._v(
                          "\n          Scheduled (" +
                            _vm._s(_vm.scheduledLoads.length) +
                            ")\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-tab", { key: "In Transit" }, [
                        _vm._v(
                          "\n          In Transit (" +
                            _vm._s(_vm.inTransitLoads.length) +
                            ")\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-tab", { key: "Delivered" }, [
                        _vm._v(
                          "\n          Delivered (" +
                            _vm._s(_vm.deliveredLoads.length) +
                            ")\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c(
                            "v-tab-item",
                            { key: "Scheduled" },
                            [
                              _c("scheduled-loads", {
                                attrs: {
                                  disabledRouting: "",
                                  "loading-list": _vm.loading,
                                  dispatched: "",
                                  status: _vm.loadStatus.SCHEDULED,
                                  loads: _vm.scheduledLoads
                                },
                                on: {
                                  refresh: function($event) {
                                    return _vm.getBookedLoads()
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab-item",
                            { key: "In Transit" },
                            [
                              _c("scheduled-loads", {
                                attrs: {
                                  loads: _vm.inTransitLoads,
                                  "loading-list": _vm.loading,
                                  disabledRouting: "",
                                  dispatched: "",
                                  status: _vm.loadStatus.IN_TRANSIT
                                },
                                on: {
                                  refresh: function($event) {
                                    return _vm.getBookedLoads()
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab-item",
                            { key: "Delivered" },
                            [
                              _c("scheduled-loads", {
                                attrs: {
                                  loads: _vm.deliveredLoads,
                                  "loading-list": _vm.loading,
                                  dispatched: "",
                                  disabledRouting: "",
                                  status: _vm.loadStatus.DELIVERED
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$vuetify.breakpoint.smAndDown
        ? _c(
            "div",
            { staticClass: "pt-3" },
            [
              _c("v-text-field", {
                staticClass: "mb-2 single-line hide-details",
                attrs: { "append-icon": "search", label: "Search loads" },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              }),
              _vm._v(" "),
              _c("v-select", {
                staticClass: "mb-2",
                attrs: {
                  items: _vm.mobileSortOptions,
                  "menu-props": "auto",
                  label: "Sort by",
                  "hide-details": "",
                  "append-icon": "sort",
                  "single-line": ""
                },
                model: {
                  value: _vm.sortValue,
                  callback: function($$v) {
                    _vm.sortValue = $$v
                  },
                  expression: "sortValue"
                }
              }),
              _vm._v(" "),
              _c("h2", { staticClass: "title mobile-title" }, [
                _vm._v("Scheduled (" + _vm._s(_vm.scheduledLoads.length) + ")")
              ]),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c("scheduled-loads", {
                    attrs: {
                      disabledRouting: "",
                      "loading-list": _vm.loading,
                      dispatched: "",
                      status: _vm.loadStatus.SCHEDULED,
                      loads: _vm.scheduledLoads
                    },
                    on: {
                      refresh: function($event) {
                        return _vm.getBookedLoads()
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "title mobile-title" }, [
                _vm._v("In Transit (" + _vm._s(_vm.inTransitLoads.length) + ")")
              ]),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c("scheduled-loads", {
                    attrs: {
                      loads: _vm.inTransitLoads,
                      "loading-list": _vm.loading,
                      disabledRouting: "",
                      dispatched: "",
                      status: _vm.loadStatus.IN_TRANSIT
                    },
                    on: {
                      refresh: function($event) {
                        return _vm.getBookedLoads()
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "title mobile-title" }, [
                _vm._v("Delivered (" + _vm._s(_vm.deliveredLoads.length) + ")")
              ]),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c("scheduled-loads", {
                    attrs: {
                      loads: _vm.deliveredLoads,
                      "loading-list": _vm.loading,
                      disabledRouting: "",
                      dispatched: "",
                      status: _vm.loadStatus.DELIVERED
                    },
                    on: {
                      refresh: function($event) {
                        return _vm.getBookedLoads()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6caa8593", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6caa8593","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/User/MyAssignedLoads.vue
// module id = null
// module chunks = 